// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { LanguagesBaseService } from './languages-base.service';
import { Constants, LanguageModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class LanguagesMockService extends LanguagesBaseService {
  constructor() {
    super();
  }

  initialiseLanguage(selectedLanguageId: number): void {
    this.languages$.subscribe(langs => {
      const selectedLanguage = langs.find(l => {
        return l.id === selectedLanguageId;
      });
      this._selectedLanguage$.next(selectedLanguage);
    });
  }

  setSelectedLanguage(selectedLanguage: LanguageModel): void {
    this._selectedLanguage$.next(selectedLanguage);
  }

  loadLanguages(): void {
    let languages = new Array<LanguageModel>();

    languages = [
      Constants.DEFAULT_LANGUAGE,
      {
        id: 2,
        name: 'English - USA',
        nativeName: '\'merican',
        isoTwoLetterName: 'en',
        isoThreeLetterName: 'USA',
        cultureCode: 'US',
        isRtl: false
      }
    ];

    this._languages$.next(languages);
  }
}
